import screenSize from './screen_size';
import config from '../config';
import $ from 'jquery';
import _get from 'lodash.get';

class AnalyticsService {
    constructor() {
        this.config = config;
        this.screenSize = screenSize;
        this.env = config.get('env');
    }

    /* TODO: add to search*/
    trackSearch() {
        window.fbq('track', 'Search');
        return this;
    }

    onSlideshowRefresh() { /* Invoke the following trackers doing slideshow slide event*/
        this.trackComscore();
        this.trackNielsen();
        this.trackFacebookAds();
    }

    trackChartbeat(conf) {
        var loading = 0;

        function performChartbeatTracking() { /* The actual action of setting up variables to pass to analytics*/
            const model = conf || window.bootstrapObj;
            const series = model.series;
            const author = model.author.display_name;
            const siteName = model.site.name;
            let cbAuthors = '';
            let cbSections = '';
            let cbSponsoredName = '';
            /* TODO: add for infinite scroll*/
            if (window._sf_async_config && !conf) { /* Author name*/
                if (author) {
                    cbAuthors = author;
                }
                /* Section*/
                if (series && series.supertag) {
                    cbSections = series.supertag.plain;
                } else {
                    cbSections = siteName;
                }
                /* Series*/
                if (series && series.sponsored && series.sponsored === true) {
                    if (series.advertiser && series.advertiser !== '') {
                        cbSponsoredName = series.advertiser + ' | ' + series.title;
                    }
                }
                window._sf_async_config.authors = cbAuthors;
                window._sf_async_config.sections = cbSections;
                window._sf_async_config.sponsorName = cbSponsoredName;
            }
            window.pSUPERFLY.virtualPage(window.location.pathname);
            /* console.log('track chartbeat', window._sf_async_config);*/
        }

        /* If the script or object doesn't exist, we need to load it in*/
        if (typeof window.pSUPERFLY === 'undefined' && loading === 0) {
            loading = 1;
            const chartbeatScript = (document.location.protocol === 'https:') ? 'https://a248.e.akamai.net/chartbeat.download.akamai.com/102508/js/chartbeat.js' : 'http://static.chartbeat.com/js/chartbeat_pub.js';
            $.getScript(chartbeatScript, (data, textStatus) => {
                if (textStatus === 'success') {
                    performChartbeatTracking();
                }
            });
        } else {
            performChartbeatTracking();
        }
    }

    trackKrux(bootstrapConf, bootstrapObj, omnitureConf) {
        if (bootstrapConf || bootstrapObj) {
            window.FC_Krux_FPA = { // eslint-disable-line camelcase
                author: null,
                channels: null,
                subChannels: null,
                contentType: null,
                keywords: null,
                socialTags: null,
                siteName: null,
                referrerUrl: null,
                url: location.origin + location.pathname,
                querystring: null
            };

            if (location.search !== '') {
                window.FC_Krux_FPA.querystring = location.search; // eslint-disable-line camelcase
            }

            if (document.referrer) {
                window.FC_Krux_FPA.referrerUrl = document.referrer; // eslint-disable-line camelcase
            }

            if (bootstrapObj && bootstrapObj.identity) {
                if (bootstrapObj.identity && bootstrapObj.identity.keywords) {
                    window.FC_Krux_FPA.channels = bootstrapObj.identity.keywords; // eslint-disable-line camelcase
                }
                if (bootstrapObj.identity.site_name) {
                    window.FC_Krux_FPA.siteName = bootstrapObj.identity.site_name; // eslint-disable-line camelcase
                }
            }
            if (bootstrapConf) {
                if (bootstrapConf.author && bootstrapConf.author.display_name) {
                    window.FC_Krux_FPA.author = bootstrapConf.author.display_name; // eslint-disable-line camelcase
                }
                if (bootstrapConf.labels && bootstrapConf.labels.topics) {
                    window.FC_Krux_FPA.subChannels = bootstrapConf.labels.topics; // eslint-disable-line camelcase
                }
                if (bootstrapConf.keywords) {
                    if (bootstrapConf.keywords.tags) {
                        window.FC_Krux_FPA.keywords = bootstrapConf.keywords.tags; // eslint-disable-line camelcase
                    }
                    if (bootstrapConf.keywords.socialtags) {
                        window.FC_Krux_FPA.socialTags = bootstrapConf.keywords.socialtags; // eslint-disable-line camelcase
                    }
                }
                if (bootstrapConf.kind) {
                    window.FC_Krux_FPA.contentType = bootstrapConf.kind; // eslint-disable-line camelcase
                }
            }
        }
        if (omnitureConf) {
            if (omnitureConf && omnitureConf.fastco_s && omnitureConf.fastco_s.props && omnitureConf.fastco_s.props.length) {
                window.FC_Krux_FPA['Read Length'] = omnitureConf.fastco_s.props[34] || null;
                window.FC_Krux_FPA['Article ID'] = omnitureConf.fastco_s.props[10] || null;
                window.FC_Krux_FPA.Subchannel = omnitureConf.fastco_s.props[2] || null;
                window.FC_Krux_FPA.Channel = omnitureConf.fastco_s.props[1] || null;
            }
        }
        Krux('ns:mansueto', 'page:load', function () { // eslint-disable-line new-cap
        }, {pageView: true});
    }

    trackComscore(conf) {
        var loading = 0;

        function performComscoreTracking() {
            const model = conf || window.bootstrapObj;
            let site = false;
            if (_get(model, 'site.slug')) {
                site = model.site.slug.toUpperCase();
            } else {
                site = location.hostname;
            }
            // reset COMSCORE
            window.COMSCORE.beacon({
                c1: 2,
                c2: 6916907,
                options: {
                    url_append: 'comscorekw=' + site
                }
            });
            // console.log('perform comscore tracking', site);
        }

        if (typeof window.COMSCORE === 'undefined' && loading === 0) {
            loading = 1;
            $.getScript('//b.scorecardresearch.com/beacon.js', (data, textStatus) => {
                if (textStatus === 'success') {
                    performComscoreTracking();
                }
            });
            // console.log('Comscore Error:');
        } else {
            performComscoreTracking();
        }
    }

    trackNielsen() {
        var loading = 0;

        if (typeof window.Nielsen_Event !== 'function' && loading === 0) {
            loading = 1;
            /* eslint-disable */
            // No where to get that script
            (function Nielsen_Event() {
                let d = new Image(1, 1);
                d.onerror = d.onload = function () {
                    d.onerror = d.onload = null;
                };
                d.src = ['//secure-us.imrworldwide.com/cgi-bin/m?ci=us-805310h&cg=0&cc=1&si=', escape(window.location.href),
                    '&rp=', escape(document.referrer),
                    '&ts=compact&c0=usergen,1&rnd=', (new Date()).getTime()].join('');
                // console.log('nielsen dynamic load');
            })();
        } else {
            window.Nielsen_Event();
            /* eslint-enable */
            // console.log('using neilsen from win');
        }
    }

    trackFacebookAds(conf) {
        var loading = 0;

        function performFBAdsTracking() {
            const model = conf || window.bootstrapObj;
            const series = model.series;
            const kind = model.kind;
            const type = model.type;

            window._fbq.push(['addPixelId', '6025492976361']);
            window._fbq.push(['track', 'User', {
                type: type,
                kind: kind,
                supertag: (series && series.title) ? series.title : '',
                sponsored: (series && series.sponsored === true) ? 'true' : 'false'
            }]);

            // Conversion Event
            window._fbq.push(['track', 'ViewPage', {
                referrer: document.referrer,
                userAgent: navigator.userAgent,
                language: navigator.language
            }]);
            // console.log('perform fb ad tracking');
        }

        if (typeof window._fbq === 'undefined' && loading === 0) {
            loading = 1;
            $.getScript('//connect.facebook.net/en_US/fbds.js', (data, textStatus) => {
                if (textStatus === 'success') {
                    performFBAdsTracking();
                }
            });
        } else {
            performFBAdsTracking();
        }
    }

    trackGAEvent(eventCategory, eventAction, eventLabel) {
        if (this.env !== 'development') {
            window.ga('send', 'event', eventCategory, eventAction, eventLabel);
        }
    }

    handleOutboundLinkClicks(eventCategory, eventAction, eventLabel) {
        const eventInfo = {
            eventCategory: eventCategory,
            eventAction: eventAction,
            eventLabel: eventLabel,
            transport: 'beacon'
        };
        this.sendGAEvent(eventInfo);
    }

    sendGAEvent(eventInfo) {
        window.ga('send', 'event', eventInfo);
    }

    trackInfiniteScrollPage(index) {
        window.ga('send', 'event', 'infinite_scroll_page_num', index);
        window.ga('send', 'pageview', location.href);
    }

    trackOmnitureEvent(sEvent, sValue) {
        if (!window.fastco_s) {
            // console.error('Omniture not initialized, please include omniture s_code.js');
            return;
        }

        if (!sEvent || !sValue) {
            // console.error('Tracking parameters not provided');
            return;
        }

        //sEvent needs to be in proper format, example event24 where 24 is the number corresponding to event set up in Omniture reporting
        window.fastco_s.linkTrackVars = 'events';
        window.fastco_s.linkTrackEvents = sEvent;
        window.fastco_s.events = sEvent;
        window.fastco_s.tl(this, 'o', sValue);
    }

    gaTrackPageView() {
        ga('send', 'pageview', location.href);
    }
}

const analyticsService = new AnalyticsService();

export default analyticsService;
